import { Navigate } from "react-router-dom";

export default function TerminalCreatePage() {
  return <Navigate to="/forex/terminal" replace />;
}
